import { formatSalesValue } from './../../utils/formatUtils';

const EmployeeTable = ({ employeeData, loading, handleIndividualDetails }) => {
    const totals = employeeData.reduce(
        (acc, employee) => {
            acc.guests += Number(employee.noOfGuests) || 0;
            acc.food += Number(employee.Food_Sales) || 0;
            acc.beverage += Number(employee.Beverage_Sales) || 0;
            acc.totalSales += Number(employee.Total_Sales) || 0;
            acc.void += Number(employee.Void_Order_Count) || 0;
            acc.discount += Number(employee.Discounts_Sales) || 0;

            return acc;
        },
        {
            guests: 0,
            food: 0,
            beverage: 0,
            totalSales: 0,
            void: 0,
            discount: 0,
        }
    );

    totals.revPerGuest = totals.guests > 0 ? totals.totalSales / totals.guests : 0;

    return (
        <div className="rounded-md border overflow-auto max-h-[600px] tiny-scrollbar">
            <table className="text-center text-sm min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50 sticky top-0 z-10">
                    <tr>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Employee</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Guests</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Food</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Beverage</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Total Sales</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Void</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Revenue per Guest</th>
                        <th className="px-2 py-2.5 text-xs font-medium text-gray-700 uppercase tracking-wider">Discount</th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {employeeData.length > 0 ? (
                        employeeData.map((employee, index) => (
                            <tr key={index} className="hover:bg-gray-50">
                                <td className="p-2 whitespace-nowrap text-sm text-gray-900 hover:underline">
                                    <div className='hover:cursor-pointer' onClick={() => handleIndividualDetails(employee)}>
                                        {employee.Employee}
                                    </div>
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {employee.noOfGuests}
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Food_Sales)}
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Beverage_Sales)}
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Total_Sales)}
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {employee.Void_Order_Count || '-'}
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.RevperGuest)}
                                </td>
                                <td className="p-2 whitespace-nowrap text-sm text-gray-700">
                                    {formatSalesValue(employee.Discounts_Sales)}
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="8" className="px-4 py-6 text-center text-sm text-gray-700">
                                {loading ? "Loading data..." : "No employee data available"}
                            </td>
                        </tr>
                    )}
                </tbody>
                <tfoot className="sticky bottom-0 bg-gray-100 border-t-2 border-gray-300 font-semibold">
                    <tr>
                        <td className="p-2">Total</td>
                        <td className="p-2">{totals.guests}</td>
                        <td className="p-2">{formatSalesValue(totals.food)}</td>
                        <td className="p-2">{formatSalesValue(totals.beverage)}</td>
                        <td className="p-2">{formatSalesValue(totals.totalSales)}</td>
                        <td className="p-2">{totals.void}</td>
                        <td className="p-2">{formatSalesValue(totals.revPerGuest)}</td>
                        <td className="p-2">{formatSalesValue(totals.discount)}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

export default EmployeeTable